import { useMemo } from 'react';
import { getIsEnrollmentClosed } from '../utils';
import WebNotifyMe from './WebNotifyMe';
import OnGoingEnrollmentBatchesNotifyMe from './OnGoingEnrollmentBatchesNotifyMe';

const NotifyMeState = ({ batchDetails = {} }) => {
  const isEnrolled = batchDetails?.isEnrolled ?? false;

  const isEnrollmentClosed = useMemo(
    () => getIsEnrollmentClosed(batchDetails.enrollmentEndDate),
    [batchDetails.enrollmentEndDate]
  );

  // if user is enrolled in batch, don't show notify me banner
  if (isEnrolled) return null;

  // if user is not enrolled in batch, enrollment for the batch is ended
  const isShowNotifyingForEnrollmentClosed = isEnrollmentClosed;
  if (isShowNotifyingForEnrollmentClosed) return <WebNotifyMe />;

  const isShowNotifyingForEnrollmentOnGoing = !isEnrollmentClosed;
  // if user is not enrolled in batch, enrollment for the batch is going on
  if (isShowNotifyingForEnrollmentOnGoing)
    return <OnGoingEnrollmentBatchesNotifyMe />;
  return null;
};
export default NotifyMeState;
